(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/components/pd-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/components/pd-card.js');
'use strict';

const {
  Card
} = svs.ui.ReactCard;

const PdCard = _ref => {
  let {
    children,
    isFocused = false,
    onChange = () => {}
  } = _ref;
  return React.createElement(Card, {
    branding: "sport",
    className: "padding-bottom-1",
    expandable: true,
    expandableList: true,
    isInitalExpanded: isFocused,
    onChange: onChange
  }, children);
};
svs.myProfile.react.pages.myInformation.myInformation.components.PdCard = PdCard;

 })(window);